import * as Styled from '../../policy.styled';

export default function UseRestrictionPolicyZh() {
  return (
    <Styled.MainWrapper style={{ marginTop: 40 }}>
      <h3 style={{ marginBottom: '40px' }}>營運規章</h3>
      本營運規章旨在說明，由BubbleTap
      Corp.（以下簡稱「本公司」）所提供的「Tingle」、「獎勵」等服務（以下簡稱「本服務」），其營運方針與管理原則。本政策規範了處理服務內可能發生的問題、以及管理與本服務相關內容（請參閱《服務條款》第
      2 條第 2
      項）的具體準則。若您違反本營運規章，可能會依據違規次數或嚴重性，在本公司提供的所有服務中受到懲處，請務必仔細閱讀。此外，本營運政策中使用的專有名詞，其定義與《服務條款》中的定義相同。
      <br />
      <br />
      本公司致力於透過與會員持續交流，並根據各位的寶貴意見，制定出更完善的服務相關營運規章。若有任何政策變動，本公司將至少提前
      7 天透過服務公告發布。
      <p>第1條 會員的權利與義務</p>
      <ol>
        ① 會員的權利
        <br />
        會員可以透過線上客服中心等管道詢問各項服務問題。
        <br />
        <br />② 會員的義務
        <ol>
          <li>
            會員不得在服務中從事違反法令、服務條款、營運規章或其他妨礙其他會員使用服務的行為。若違反此義務，本公司將依內部規定，在不另行通知的情況下，限制其使用服務。
          </li>
          <li>
            會員應隨時確認服務條款、營運規章等規定，及公司網站公告等，若因未確認而導致相關問題，本公司可能難以提供協助。
          </li>
          <li>
            若使用者有侵害公司或其他第三者的著作權等智慧財產權、損害名譽、妨礙業務，或其他違反相關法令的行為，可能會被限制使用服務，且須依相關法令負擔民刑事責任。
          </li>
        </ol>
      </ol>
      <p>第2條 服務使用限制措施</p>
      若公司的服務使用者從事違反第3條營運規章的活動，將根據違規次數或本公司判定的違規嚴重程度，依下列階段採取使用限制措施。限制措施不一定會照順序執行，將依本公司的內部政策決定。但若行為情節嚴重，可能會不經由階段性處理，直接採取高階段的措施。
      <br />
      <br />
      <ol>
        ① 服務使用相關階段性措施
        <li>第1階段： 政策告知並將該內容設為不公開或刪除。</li>
        <li>第2階段： 將該內容設為不公開或刪除後，禁止使用公司旗下各社群 / 社交平台功能最多7天。</li>
        <li>第3階段： 將該內容設為不公開或刪除後，禁止使用該帳號最多7天。</li>
        <li>第4階段： 將該內容設為不公開或刪除後，禁止使用該帳號最多30天。</li>
        <li>第5階段： 將該內容設為不公開或刪除後，永久禁止使用該帳號。</li>
      </ol>
      <ol>
        ② 創作物、AI角色、AI故事情節、AI故事背景等（以下稱「AI素材」）發布相關的階段性措施。
        <li>第1階段： 政策告知，並將該創作物或AI素材設為不公開或刪除。</li>
        <li>2第2階段： 將該創作物或AI素材設為不公開或刪除後，禁止創作內容及消費最多7天。</li>
        <li>第3階段： 將該創作物或AI素材設為不公開或刪除後，禁止使用該帳號最多7天。</li>
        <li>第4階段： 將該創作物或AI素材設為不公開或刪除後，禁止使用該帳號最多30天。</li>
        <li>第5階段： 將該創作物或AI素材設為不公開或刪除後，永久禁止使用該帳號。</li>
      </ol>
      <ol>
        ③ 申訴
        <li>使用者可就此類使用限制措施提出異議。 </li>
        <li>第1階段和第5階段的申訴期間為30天，第2至4階段則可在懲處期間內進行申訴。</li>
        <li>公司將在收到異議申請後的3至5個工作天內進行審核，若理由適當，將立即恢復使用。</li>
        <li>
          但若在提出異議時，持續對公司有辱罵、淫穢言論、威脅及其他妨礙公司正常業務運作的行為，公司可不對異議事項進行審理等後續程序。
        </li>
      </ol>
      <p>第3條 使用限制活動</p>
      如果使用者有以下行為，將構成第2條所規範之使用限制措施的事由。
      <br />
      <br />
      <ol>
        ① 與服務使用相關的限制活動
        <li>
          侵犯個人資訊
          <ol>
            <li>洩露他人資訊的行為</li>
            <li>非法使用其他會員帳號的行為</li>
            <li>轉讓或與他人共用帳號等，有合理理由懷疑是不正當使用帳號的行為</li>
            <li>未經同意蒐集、儲存、公開其他會員個人資訊的行為</li>
          </ol>
        </li>
        <li>
          駭客攻擊
          <ol>
            <li>透過手機駭客攻擊等方式竄改 UUID 來使用服務的行為。</li>
            <li>未經公司特別授權，擅自更改公司用戶端程式或駭客入侵伺服器的行為。</li>
            <li>利用公司尚未發現或未修復的服務漏洞來使用服務，或查閱非公開資料並偽造、篡改資訊的行為。</li>
            <li>使用自動連線程式等非正常方式使用服務，造成公司伺服器負擔，妨礙公司正常服務運作的行為。</li>
          </ol>
        </li>
        <li>
          非法營利活動
          <ol>
            <li>宣傳非法、賭博網站</li>
            <li>銷售或宣傳非法產品。</li>
            <li>未經公司同意或違反公司詳細使用指南等，從事營利活動的行為。</li>
            <li>發送可能妨礙服務穩定運作的資訊，以及違反收件人明確拒收意願的廣告資訊或垃圾郵件。</li>
            <li>客觀上被認定與犯罪有關的行為。</li>
            <li>其他違反相關法律法規、非法或不正當的行為。</li>
          </ol>
        </li>
        <li>
          侵害著作權
          <ol>
            <li>
              未經同意發布、使用或以其他方式散布侵犯公司及其他會員或第三方之專利、商標、商業機密、著作權及其他智慧財產權的內容。
            </li>
            <li>未經合法授權或公司同意，複製、流通或以營利為目的使用透過公司服務獲取的資訊。</li>
            <li>提供可透過非法途徑獲取他人著作物的資訊或方法。</li>
            <li>未經當事人同意，分享影片、音樂、電影、漫畫等他人的著作物。</li>
            <li>未經授權，侵犯他人商標權、設計權等權利。</li>
            <li>侵犯已接獲著作權人檢舉的著作物。</li>
            <li>除了上述行為，其他構成著作權侵權的行為。</li>
          </ol>
        </li>
        <li>
          妨礙服務使用
          <ol>
            <li>透過粗言穢語、辱罵、洗版、跟蹤騷擾等方式，造成羞恥、厭惡、恐懼，從而妨礙其他會員使用服務的行為。</li>
            <li>為了吸引搜尋流量而上傳大量非人力所及的過度內容，並被判斷為有惡意目的的行為。</li>
            <li>發布來源不明的貼文或散播謠言。</li>
          </ol>
        </li>
        <li>
          散布淫穢內容
          <ol>
            <li>連結（提供連結）至色情網站的行為。</li>
            <li>分享與性交易相關的資訊。</li>
          </ol>
        </li>
        <li>
          歧視與製造衝突
          <ol>
            <li>進行基於性別、宗教、身心障礙、年齡、社會身分、種族、地區、職業等因素的歧視或製造偏見的活動。</li>
            <li>進行或煽動政治宣傳。</li>
            <li>除了上述項目之外，其他製造歧視與衝突的行為。</li>
          </ol>
        </li>
        <li>
          發布貼文
          <ol>
            <li>發布及修改貼文時寫下假消息的行為</li>
            <li>編寫包含非正常或非法程式的散布及使用方法的內容</li>
            <li>在未事先獲得批准的情況下，利用他人的著作物來編寫貼文</li>
            <li>編寫可透過非法途徑獲取他人著作物的資訊或方法的內容</li>
            <li>反覆發布相同內容的貼文，妨礙他人使用服務的行為</li>
            <li>刊登淫穢物品或編寫與性交易相關的資訊貼文</li>
            <li>對他人進行貶低、誹謗、辱罵等行為</li>
            <li>編寫歧視或助長性別、宗教、身心障礙、年齡、社會身分、種族、地區、職業等偏見的內容</li>
            <li>刊登政治煽動或誘導的內容</li>
            <li>除了上述項目之外，編寫妨礙他人使用服務或包含非法內容的文章</li>
          </ol>
        </li>
        <li>
          其他
          <ol>
            <li>冒充公司或相關人士的行為</li>
            <li>損害公司及其他第三方的名譽或使其蒙受損失。</li>
            <li>更改公司發布的資訊</li>
            <li>在暱稱、貼文、留言中冒充公司、其他業者或著作權人，或有其他意圖惡用服務而非正當使用服務的行為。</li>
            <li>明確表示不再使用服務並同意重新註冊限制後退出服務的行為。</li>
            <li>進行上述項目之外，服務中禁止的活動。</li>
          </ol>
        </li>
      </ol>
      <ol>
        ② 關於發布創作物及AI素材的限制
        <li>
          活動
          <ol>
            <li>色情內容</li>
            <li>發布未標示為成人內容的色情內容。</li>
            <li>任意更改成人內容的年齡分級。</li>
            <li>集中描寫國家通訊傳播委員會中定義的無法流通的描寫，或社會普遍無法容忍的行為。</li>
            <li>未經馬賽克處理（可辨識輪廓的程度以上），赤裸裸地描寫性器官或其他性行為。</li>
            <li>若判斷有違反其他相關法律法規且需緊急處理的情況。</li>
          </ol>
        </li>
        <li>
          兒少性剝削
          <ol>
            <li>根據社會觀念，描寫未滿18歲的兒童及青少年進行性行為的內容。</li>
            <li>描寫可明確辨識為兒童及少年的人物或表現物進行性行為的內容。</li>
          </ol>
        </li>
        <li>
          暴力
          <ol>
            <li>美化或助長可能導致嚴重傷害或死亡的自殘、自殺等行為，以及精神或身體虐待。</li>
            <li>美化藥物和武器使用等犯罪行為，或透過寫實地描寫炸彈或武器製造等犯罪方法來助長犯罪。</li>
            <li>具體描寫或助長綁架、人口販賣、殺人、傷害、酷刑、肢體損害、器官買賣等殘忍和暴力的場景。</li>
            <li>
              具體描寫或美化對尊親屬、卑親屬、老人、孕婦、身心障礙者、兒童、社會弱勢群體的威脅、傷害、施暴、殺害等，可能損害傳統倫理的行為。
            </li>
            <li>侮辱或助長對實際犯罪或事件受害者的仇恨。</li>
            <li>具體描寫屠殺、虐待動物或動物屍體等令人感到殘忍或厭惡的內容。</li>
          </ol>
        </li>
        <li>
          仇恨言論
          <ol>
            <li>
              基於種族、民族、宗教、身心障礙、年齡、國籍、性取向、性別、性別認同、規範或社會體系等問題，煽動對個人或群體的暴力或仇恨。
            </li>
            <li>使用其他會引起其他使用者厭惡和不適的言論。</li>
            <li>其他有損社會安寧秩序或公序良俗，或以該目的進行的描寫。</li>
          </ol>
        </li>
        <li>
          誘導及描述非法行為
          <ol>
            <li>提供性交易或色情資訊</li>
            <li>提供賭博資訊</li>
            <li>提供非法食品或藥品資訊</li>
            <li>提供駭客軟體或原始碼資訊</li>
            <li>教唆、協助或煽動犯罪，或有顯著引發此類行為的疑慮。</li>
            <li>冒充或影射服務相關人員：冒充服務相關人員或服務本身，或可能引起誤解。</li>
            <li>具體描述其他違法行為的計畫或執行過程。</li>
            <li>提供其他違反法律法規的資訊（如非法金融、個人資訊交易等）。</li>
          </ol>
        </li>
        <li>
          廣告
          <ol>
            <li>在廣告內容中未清楚標示經濟利益關係，使消費者無法輕易辨識其為廣告。</li>
            <li>直接或間接宣傳非法或賭博網站。</li>
            <li>直接或間接宣傳非法產品銷售。</li>
          </ol>
        </li>
        <li>
          著作權
          <ol>
            <li>發布非自身著作物的行為</li>
            <li>在未經原作者同意的情況下使用其著作物。</li>
            <li>在未經授權的情況下，使用原創作者和原創作品明確的著作物之部分或全部。</li>
            <li>
              在原創作品和原創作者廣為人知，且合法流通途徑明確的情況下，擅自轉載或散布整個創作物，明顯侵犯著作權的行為。
            </li>
          </ol>
        </li>
        <li>
          內容產物形式
          <ol>
            <li>人為操縱與內容相關的量化數據（例如聊天次數、按讚數等）。</li>
            <li>內容非正常（例如內容空白，或與服務宗旨不符）。</li>
            <li>其他判斷為不適合在服務中發布的內容。</li>
          </ol>
        </li>
        <li>
          其他
          <ol>
            <li>誹謗或陷害公司、其他會員或第三方，損害其名譽。</li>
            <li>散布違反公共秩序及善良風俗的資訊、文章、圖形等。</li>
            <li>違反刊物倫理委員會（現為韓國文化產業振興院）及韓國廣播通訊審議委員會規定的有害刊物審議標準。</li>
            <li>內容被認定與犯罪行為相關。</li>
            <li>內容侵犯公司或第三方之著作權或其他權利。</li>
            <li>刊登未經許可的廣告或宣傳品。</li>
            <li>刊登來源不明的貼文或散布謠言。</li>
          </ol>
        </li>
      </ol>
      <p>第4條 服務使用檢舉制度</p>
      ① 會員若發現違反相關法令、服務條款或本營運規章的貼文，可隨時向公司檢舉。
      <br />
      <br />
      ② 檢舉時，必須提供檢舉對象的網址（如
      URL）和理由。這些資訊將會提交給公司負責人，由負責人據審慎審核是否應採取限制措施。
      <br />
      <br />
      ③ 若檢舉對象經判斷並未明顯違反相關法令、服務條款或本營運規章，則可能不會採取任何措施，即使檢舉人認為應受處理。
      <br />
      <br />
      ④ 即使已就檢舉事項做出判斷，但若後續有法院判決或權責機關的處分，導致先前判斷有誤，公司仍可變更原先的決定。
      <br />
      <br />⑤
      在審核檢舉內容的過程中，除了對檢舉對象採取措施外，也可能對該會員帳號實施使用限制。此類情況下，公司將綜合考量該會員的服務使用紀錄、違反營運規章的紀錄及其嚴重程度、相關法令、服務使用條款以及本營運政策等因素來做出決定。
      <p>第5條 服務休眠政策（針對長期未登入會員的措施）</p>
      ① 連續一年未登入，則個人資料將會被另外儲存。
      <br />
      <br />② 個人資料另外儲存後，若連續四年未登入，則個人資料將會被銷毀且終止使用合約。
      <br />
      <p>第6條 禁止濫用退款政策</p>
      ① 退款濫用：若使用者透過公司內部貨幣（參照服務條款第 2 條第 1 項）購買並使用公司的數位商品或服務後，再經由Google
      Play Console、Apple App
      Store或其他平台申請退款，此類濫用退款及數位竊盜行為將被視為詐欺性不法行為及竊盜。公司將此行為視為違反服務條款及營運規章。
      <br />
      <br />
      ② 針對退款濫用案例，公司有最終決定權。使用者放棄提出異議的權利，並同意接受公司的決定。
      <br />
      <br />③ 使用者若涉及退款濫用，將會受到以下處理。
      <ol>
        <li>
          法律措施：公司保留對所有確認涉及退款濫用的使用者採取法律行動的權利。公司將依據相關法令，提起民事訴訟，以追回因退款濫用所造成的損失。
        </li>
        <li>
          永久封鎖：涉及退款濫用的使用者將被永久封鎖，無法再使用公司的平台。此封鎖措施將適用於該使用者的所有帳號和裝置，無限期禁止其使用公司的服務。
        </li>
      </ol>
      ④ 零容忍政策（zero-tolerance
      policy）：公司對退款濫用行為採取無法容忍的政策。我們致力於保護平台的完整性、為使用者提供有效的服務、保護內容創作者的權利，並確保所有使用者都能享有公平且透明的體驗。
      <br />
      <br />⑤ 使用者義務：使用者在使用公司平台服務時，即表示同意以下事項。
      <ol>
        <li>不從事任何形式的退款濫用行為。</li>
        <li>始終遵守服務條款及營運規章。</li>
        <li>若發現疑似退款濫用的情況，應立即向本公司檢舉。</li>
      </ol>
    </Styled.MainWrapper>
  );
}
